import {useMatch} from '@github-ui/react-router'
import {
  ChangesRoutePath,
  ChecksRoutePath,
  CommitsRoutePath,
  FilesRoutePath,
  FindingsRoutePath,
  OverviewRoutePath,
  WalkthroughRoutePath,
} from '../routes/route-paths'

export type PullRequestActiveRoute =
  | 'overview'
  | 'conversation'
  | 'files_changed'
  | 'commits'
  | 'checks'
  | 'findings'
  | 'walkthrough'

/** Returns which pull request route is currently active. */
export function useActiveRoute(): PullRequestActiveRoute {
  const isOverview = useMatch(`${OverviewRoutePath}/*`) !== null
  const isFiles = useMatch(`${FilesRoutePath}/*`) !== null
  const isChanges = useMatch(`${ChangesRoutePath}/*`) !== null
  const isCommits = useMatch(`${CommitsRoutePath}/*`) !== null
  const isChecks = useMatch(`${ChecksRoutePath}/*`) !== null
  const isFindings = useMatch(`${FindingsRoutePath}/*`) !== null
  const isWalkthrough = useMatch(`${WalkthroughRoutePath}/*`) !== null

  if (isOverview) return 'overview'
  if (isFiles || isChanges) return 'files_changed'
  if (isCommits) return 'commits'
  if (isChecks) return 'checks'
  if (isFindings) return 'findings'
  if (isWalkthrough) return 'walkthrough'
  return 'conversation'
}
